import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getStatusColor(status) {
  switch(status) {
    case 'hot': return 'bg-red-50 text-red-700 border-red-200';
    case 'warm': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'new': return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'not_connected': return 'bg-gray-100 text-gray-600 border-gray-300';
    case 'not_answered': return 'bg-orange-50 text-orange-600 border-orange-200';
    case 'not_interested': return 'bg-rose-50 text-rose-700 border-rose-200';
    case 'already_purchased': return 'bg-teal-50 text-teal-700 border-teal-200';
    case 'customer': return 'bg-green-50 text-green-700 border-green-200';
    case 'follow_up': return 'bg-purple-50 text-purple-700 border-purple-200';
    case 'follow_up_later': return 'bg-indigo-50 text-indigo-700 border-indigo-200';
    default: return 'bg-slate-100 text-slate-600 border-slate-200';
  }
}

export function getStatusBadgeColor(status) {
  switch(status) {
    case 'hot': return '#EF4444';
    case 'warm': return '#F59E0B';
    case 'new': return '#3B82F6';
    case 'not_connected': return '#6B7280';
    case 'not_answered': return '#EA580C';
    case 'not_interested': return '#F43F5E';
    case 'already_purchased': return '#14B8A6';
    case 'customer': return '#22C55E';
    case 'follow_up': return '#A855F7';
    case 'follow_up_later': return '#6366F1';
    default: return '#94A3B8';
  }
}

export function getStatusLabel(status) {
  const labels = {
    'new': 'New',
    'hot': 'Hot',
    'warm': 'Warm',
    'not_connected': 'Not Connected',
    'not_answered': 'Not Answered',
    'not_interested': 'Not Interested',
    'already_purchased': 'Already Purchased',
    'customer': 'Customer',
    'follow_up': 'Follow Up',
    'follow_up_later': 'Follow Up Later'
  };
  return labels[status] || status;
}